'use client';

import { Box, CircularProgress } from '@mui/material';
import { useDocumentImageWithSociety } from '@/hooks/publicSearch/useDocumentImageWithSociety';
import { extractFirstImgSrc } from '@/utils/stripHtmlForTooltip';

/** Renders img-only ILR2 markup (`<img src="/online/images/…">`) via the document proxy. */
export function Ilr2StructuredImgCell({
  value,
  societyId,
  alt = 'Badge',
}: {
  value: string;
  societyId: string | number;
  alt?: string;
}) {
  const url = extractFirstImgSrc(value);
  const { imgSrc, isLoading, error } = useDocumentImageWithSociety(
    url,
    societyId,
  );

  if (!url) {
    return null;
  }

  if (error || (!isLoading && !imgSrc)) {
    return null;
  }

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 24,
          minWidth: 24,
        }}
      >
        <CircularProgress size={16} />
      </Box>
    );
  }

  if (!imgSrc) {
    return null;
  }

  return (
    <Box
      component="img"
      src={imgSrc}
      alt={alt}
      sx={{ display: 'block', maxHeight: 24, maxWidth: '100%', height: 'auto' }}
    />
  );
}
